// 관리자 — 이용도우미 FAQ 스크린샷 가이드 관리 (2c)
// 가이드(질문) CRUD + 단계 스크린샷 업로드/캡션/삭제. 위젯에서 질문 클릭 시 이 스크린샷 가이드가 노출됨.
import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

var ROLE_OPTIONS = [
  { value: 'user', label: '수출업체' },
  { value: 'doc_agency', label: '서류대행' },
  { value: 'cancel_agency', label: '말소대행' },
  { value: 'admin', label: '관리자' }
];
var roleSummary = function (roles) {
  if (!roles || !roles.length) return '전체 공개';
  return ROLE_OPTIONS.filter(function (o) { return roles.indexOf(o.value) >= 0; }).map(function (o) { return o.label; }).join('·');
};

function AdminGuides(props) {
  var showToast = props.showToast;
  var _guides = useState([]); var guides = _guides[0]; var setGuides = _guides[1];
  var _active = useState(null); var active = _active[0]; var setActive = _active[1]; // guide object
  var _images = useState([]); var images = _images[0]; var setImages = _images[1];
  var _imgUrls = useState({}); var imgUrls = _imgUrls[0]; var setImgUrls = _imgUrls[1];
  var _newQ = useState(''); var newQ = _newQ[0]; var setNewQ = _newQ[1];
  var _q = useState(''); var q = _q[0]; var setQ = _q[1];
  var _title = useState(''); var title = _title[0]; var setTitle = _title[1];
  var _roles = useState([]); var roles = _roles[0]; var setRoles = _roles[1];
  var _newRoles = useState([]); var newRoles = _newRoles[0]; var setNewRoles = _newRoles[1];
  var _cap = useState(''); var cap = _cap[0]; var setCap = _cap[1];
  var _files = useState([]); var files = _files[0]; var setFiles = _files[1];
  var _busy = useState(false); var busy = _busy[0]; var setBusy = _busy[1];
  var _lightbox = useState(''); var lightbox = _lightbox[0]; var setLightbox = _lightbox[1];

  var loadGuides = function () {
    authFetch(API + '/admin/assistant/guides').then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.guides) setGuides(d.guides); }).catch(function () {});
  };
  var loadImages = function (gid) {
    authFetch(API + '/admin/assistant/guides/' + gid + '/images').then(function (r) { return r.json(); })
      .then(function (d) { if (d && d.images) setImages(d.images); }).catch(function () {});
  };
  useEffect(function () { loadGuides(); }, []);
  useEffect(function () {
    if (!active) return undefined;
    images.forEach(function (im) {
      if (imgUrls[im.id]) return;
      authFetch(API + '/admin/assistant/guides/' + active.id + '/images/' + im.id).then(function (r) { return r.blob(); })
        .then(function (b) { var u = URL.createObjectURL(b); setImgUrls(function (p) { if (p[im.id]) return p; var n = Object.assign({}, p); n[im.id] = u; return n; }); })
        .catch(function () {});
    });
    return undefined;
  }, [images, active]);

  var openGuide = function (g) { setActive(g); setQ(g.question || ''); setTitle(g.title || ''); setRoles(g.roles || []); setImages([]); setCap(''); setFiles([]); loadImages(g.id); };

  var createGuide = function () {
    if (!newQ.trim()) { showToast('질문을 입력하세요', 'err'); return; }
    authFetch(API + '/admin/assistant/guides', { method: 'POST', body: JSON.stringify({ question: newQ.trim(), roles: newRoles }) })
      .then(function (r) { return r.json(); }).then(function (d) {
        if (d && d.id) { setNewQ(''); setNewRoles([]); showToast('가이드 추가됨'); loadGuides(); }
        else showToast((d && d.error) || '추가 실패', 'err');
      }).catch(function () { showToast('서버 오류', 'err'); });
  };
  var saveGuide = function () {
    if (!active) return;
    authFetch(API + '/admin/assistant/guides/' + active.id, { method: 'PUT', body: JSON.stringify({ question: q, title: title, roles: roles }) })
      .then(function () { showToast('저장됨'); loadGuides(); }).catch(function () { showToast('서버 오류', 'err'); });
  };
  var toggleActive = function (g) {
    authFetch(API + '/admin/assistant/guides/' + g.id, { method: 'PUT', body: JSON.stringify({ active: g.active ? 0 : 1 }) })
      .then(function () { loadGuides(); }).catch(function () {});
  };
  var deleteGuide = function (g) {
    if (!window.confirm('이 가이드를 삭제할까요? (스크린샷도 함께 삭제)')) return;
    authFetch(API + '/admin/assistant/guides/' + g.id, { method: 'DELETE' })
      .then(function () { showToast('삭제됨'); if (active && active.id === g.id) setActive(null); loadGuides(); }).catch(function () {});
  };
  var uploadImages = function () {
    if (!active || !files.length) return;
    setBusy(true);
    var fd = new FormData();
    var caps = [];
    for (var i = 0; i < files.length; i++) { fd.append('files', files[i]); caps.push(i === 0 ? cap : ''); }
    fd.append('captions', JSON.stringify(caps));
    authFetch(API + '/admin/assistant/guides/' + active.id + '/images', { method: 'POST', body: fd })
      .then(function (r) { return r.json(); }).then(function () {
        setBusy(false); setFiles([]); setCap(''); showToast('스크린샷 업로드됨'); loadImages(active.id); loadGuides();
      }).catch(function () { setBusy(false); showToast('업로드 실패', 'err'); });
  };
  var deleteImage = function (imgId) {
    if (!active) return;
    authFetch(API + '/admin/assistant/guides/' + active.id + '/images/' + imgId, { method: 'DELETE' })
      .then(function () { loadImages(active.id); loadGuides(); }).catch(function () {});
  };

  var toggleRole = function (list, setList, v) {
    setList(list.indexOf(v) >= 0 ? list.filter(function (x) { return x !== v; }) : list.concat([v]));
  };
  var roleChecks = function (list, setList) {
    return (
      <div style={{ marginBottom: 8 }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, fontSize: 12 }}>
          {ROLE_OPTIONS.map(function (o) {
            return <label key={o.value} style={{ cursor: 'pointer' }}><input type="checkbox" checked={list.indexOf(o.value) >= 0} onChange={function () { toggleRole(list, setList, o.value); }} /> {o.label}</label>;
          })}
        </div>
        <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>{list.length ? '선택한 역할에게만 노출됩니다.' : '아무것도 선택하지 않으면 전체 공개입니다.'}</div>
      </div>
    );
  };

  var box = { border: '1px solid #e5e9f0', borderRadius: 10, background: '#fff' };
  return (
    <div style={{ display: 'flex', gap: 16, height: '100%' }}>
      {/* 좌: 목록 + 신규 */}
      <div style={{ width: 320, display: 'flex', flexDirection: 'column', gap: 10 }}>
        <div style={Object.assign({ padding: 12 }, box)}>
          <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 6 }}>새 가이드(질문)</div>
          <input value={newQ} onChange={function (e) { setNewQ(e.target.value); }} placeholder="예: 차량 등록증은 어떻게 올리나요?"
            style={{ width: '100%', boxSizing: 'border-box', padding: '8px 10px', border: '1px solid #d5dde8', borderRadius: 8, fontSize: 13 }} />
          <div style={{ marginTop: 8 }}>{roleChecks(newRoles, setNewRoles)}</div>
          <button onClick={createGuide} style={{ marginTop: 8, width: '100%', padding: '8px 0', border: 'none', borderRadius: 8, background: '#1B3A5C', color: '#fff', fontWeight: 700, cursor: 'pointer' }}>추가</button>
        </div>
        <div style={{ flex: 1, overflowY: 'auto' }}>
          {guides.length === 0 && <div style={{ color: '#94a3b8', fontSize: 13, textAlign: 'center', padding: 20 }}>가이드가 없습니다</div>}
          {guides.map(function (g) {
            var sel = active && active.id === g.id;
            return (
              <div key={g.id} onClick={function () { openGuide(g); }} style={Object.assign({ padding: '10px 12px', marginBottom: 8, cursor: 'pointer', borderColor: sel ? '#1B3A5C' : '#e5e9f0' }, box)}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
                  <span style={{ fontSize: 13, fontWeight: 700, color: g.active ? '#1f2937' : '#94a3b8' }}>{g.question}</span>
                  <span style={{ fontSize: 10, color: '#3b82f6', whiteSpace: 'nowrap' }}>🖼 {g.image_count || 0}</span>
                </div>
                <div style={{ marginTop: 4, fontSize: 11, color: '#64748b' }}>대상: {roleSummary(g.roles)}</div>
                <div style={{ marginTop: 6, display: 'flex', gap: 6 }}>
                  <button onClick={function (e) { e.stopPropagation(); toggleActive(g); }} style={{ fontSize: 11, padding: '2px 8px', borderRadius: 6, border: '1px solid #d5dde8', background: g.active ? '#dcfce7' : '#f1f5f9', color: g.active ? '#166534' : '#64748b', cursor: 'pointer' }}>{g.active ? '노출중' : '숨김'}</button>
                  <button onClick={function (e) { e.stopPropagation(); deleteGuide(g); }} style={{ fontSize: 11, padding: '2px 8px', borderRadius: 6, border: '1px solid #fecaca', background: '#fff', color: '#dc2626', cursor: 'pointer' }}>삭제</button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* 우: 상세 */}
      <div style={{ flex: 1, overflowY: 'auto' }}>
        {!active ? (
          <div style={{ color: '#94a3b8', fontSize: 14, textAlign: 'center', paddingTop: 60 }}>왼쪽에서 가이드를 선택하거나 새로 추가하세요.</div>
        ) : (
          <div style={Object.assign({ padding: 16 }, box)}>
            <div style={{ fontSize: 12, fontWeight: 700, color: '#475569', marginBottom: 4 }}>질문(칩 라벨)</div>
            <input value={q} onChange={function (e) { setQ(e.target.value); }} style={{ width: '100%', boxSizing: 'border-box', padding: '8px 10px', border: '1px solid #d5dde8', borderRadius: 8, fontSize: 13, marginBottom: 8 }} />
            <div style={{ fontSize: 12, fontWeight: 700, color: '#475569', marginBottom: 4 }}>제목(선택, 내부용)</div>
            <input value={title} onChange={function (e) { setTitle(e.target.value); }} style={{ width: '100%', boxSizing: 'border-box', padding: '8px 10px', border: '1px solid #d5dde8', borderRadius: 8, fontSize: 13, marginBottom: 8 }} />
            <div style={{ fontSize: 12, fontWeight: 700, color: '#475569', marginBottom: 4 }}>노출 대상 역할</div>
            {roleChecks(roles, setRoles)}
            <button onClick={saveGuide} style={{ padding: '8px 18px', border: 'none', borderRadius: 8, background: '#1B3A5C', color: '#fff', fontWeight: 700, cursor: 'pointer' }}>저장</button>

            <hr style={{ margin: '16px 0', border: 'none', borderTop: '1px solid #eef1f5' }} />
            <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 8 }}>스크린샷 단계 ({images.length})</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginBottom: 14 }}>
              {images.map(function (im, idx) {
                return (
                  <div key={im.id} style={{ width: 150 }}>
                    <div style={{ position: 'relative' }}>
                      {imgUrls[im.id]
                        ? <img src={imgUrls[im.id]} alt={'step' + idx} onClick={function () { setLightbox(imgUrls[im.id]); }} style={{ width: 150, height: 110, objectFit: 'cover', borderRadius: 8, border: '1px solid #e5e9f0', cursor: 'zoom-in' }} />
                        : <div style={{ width: 150, height: 110, borderRadius: 8, border: '1px solid #e5e9f0', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#b6c2d4' }}>…</div>}
                      <button onClick={function () { deleteImage(im.id); }} style={{ position: 'absolute', top: 4, right: 4, width: 20, height: 20, borderRadius: '50%', border: 'none', background: '#dc2626', color: '#fff', fontSize: 11, cursor: 'pointer' }}>✕</button>
                    </div>
                    <div style={{ fontSize: 11, color: '#64748b', marginTop: 3 }}>{idx + 1}. {im.caption || '(캡션 없음)'}</div>
                  </div>
                );
              })}
            </div>
            <div style={Object.assign({ padding: 12, background: '#f8fafc' }, box)}>
              <div style={{ fontSize: 12, fontWeight: 700, marginBottom: 6 }}>스크린샷 추가</div>
              <input type="file" accept="image/jpeg,image/png,image/webp" multiple onChange={function (e) { setFiles(Array.prototype.slice.call(e.target.files || [])); }} style={{ fontSize: 12 }} />
              <input value={cap} onChange={function (e) { setCap(e.target.value); }} placeholder="캡션(설명) — 첫 이미지에 적용" style={{ display: 'block', width: '100%', boxSizing: 'border-box', marginTop: 8, padding: '7px 10px', border: '1px solid #d5dde8', borderRadius: 8, fontSize: 12 }} />
              <button onClick={uploadImages} disabled={busy || !files.length} style={{ marginTop: 8, padding: '7px 16px', border: 'none', borderRadius: 8, background: busy || !files.length ? '#b6c2d4' : '#16a34a', color: '#fff', fontWeight: 700, cursor: busy || !files.length ? 'default' : 'pointer' }}>{busy ? '업로드 중…' : '업로드'}</button>
              <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 6 }}>여러 장 선택 시 선택 순서대로 단계가 됩니다. 캡션은 각 이미지 업로드 후 삭제/재업로드로 조정.</div>
            </div>
          </div>
        )}
      </div>

      {lightbox && <div onClick={function () { setLightbox(''); }} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 999999, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'zoom-out' }}>
        <img src={lightbox} alt="zoom" style={{ maxWidth: '94vw', maxHeight: '94vh', borderRadius: 8 }} />
      </div>}
    </div>
  );
}

export default AdminGuides;
